export default class ProcessedBooking {
  /**
   * The unique identifier of the processed booking.
   */
  id: string;
  /**
   * A unique identifier for the booking.
   */
  bookingId: string;
  /**
   * Amount that was charged
   */
  price: number;
  /**
   * Id of the person who paid for the event.
   */
  payeeId: string;
  /**
   * Name of the person who paid for the event.
   */
  payeeName: string;
  /**
   * The unique identifier of the linked event that this booking was made for.
   */
  eventId: string;
  /**
   * The title of the linked event that this booking was made for.
   */
  eventTitle: string;
  /**
   * The date of a recurring event
   */
  eventOccurrenceDate?: Date;
  /**
   * Status denoting if the booking has been charged successfully or not.
   */
  isSuccess: boolean;
  /**
   * Brief description of the payment.
   */
  transactionDetails: string;
  /**
   * The event start time that the transaction is for
   */
  timestamp: Date;
  /**
   * The time that the transaction was created or
   * Date when the attendee was charged. Will be createdDate for processed booking record
   */
  createdDate: Date;

  constructor(
    id: string,
    bookingId: string,
    price: number,
    payeeId: string,
    payeeName: string,
    eventId: string,
    eventTitle: string,
    isSuccess: boolean,
    transactionDetails: string,
    timestamp: string,
    createdDate: string,
    eventOccurrenceDate?: string
  ) {
    this.id = id;
    this.bookingId = bookingId;
    this.price = price;
    this.payeeId = payeeId;
    this.payeeName = payeeName;
    this.eventId = eventId;
    this.eventTitle = eventTitle;
    this.isSuccess = isSuccess;
    this.transactionDetails = transactionDetails;
    this.timestamp = new Date(timestamp);
    this.createdDate = new Date(createdDate);
    this.eventOccurrenceDate = eventOccurrenceDate
      ? new Date(eventOccurrenceDate)
      : undefined;
  }
}
